import { setCookie } from 'cookies-next';
import dayjs from 'dayjs';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useState } from 'react';

import COOKIES from 'constants/cookies';

const PAGES_EXCLUSIVES_FOR_WEBVIEW = ['/redirect/mobile-login'];

const WebViewContext = createContext({
  isFooterActive: true,
  isTopbarActive: true,
});

const WebViewProvider = ({ children, ssrAuthToken, ssrThemeColor }) => {
  const router = useRouter();
  const [isActive, setActive] = useState({
    isFooterActive: true,
    isTopbarActive: true,
  });

  useEffect(() => {
    const isPageExclusiveForWebView = PAGES_EXCLUSIVES_FOR_WEBVIEW.includes(
      router.pathname
    );

    const isWebView = isPageExclusiveForWebView || ssrAuthToken;

    setActive({
      isFooterActive: !isWebView,
      isTopbarActive: !isWebView,
    });
  }, [router, ssrAuthToken]);

  useEffect(() => {
    if (!ssrThemeColor) {
      return;
    }

    setCookie(COOKIES.WEBVIEW_APP_THEME_FALLBACK, ssrThemeColor, {
      expires: dayjs().add(2, 'months').toDate(),
      sameSite: true,
    });
  }, [ssrThemeColor]);

  return (
    <WebViewContext.Provider value={isActive}>
      {children}
    </WebViewContext.Provider>
  );
};

export const useWebView = () => useContext(WebViewContext);

WebViewProvider.propTypes = {
  ssrAuthToken: PropTypes.string,
  ssrThemeColor: PropTypes.string,
};

export default WebViewProvider;
